module.exports = __webpack_public_path__ + "static/media/8776.66659404.png";